module.exports = __webpack_public_path__ + "img/terroir-liquify-2-mobile.90b4c282.jpg";